export default {
  // new Intl.NumberFormat('en-US',{ style: 'currency', currency: 'USD' }).format(money); // '$100.00'
  // currentMonthTotal: state => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Math.round(state.currentMonthTotal)),
  heroGraphData: state => state.heroGraphData,
  refreshRequired: state => state.refreshRequired,
  snFilter: state => state.snFilter,
}
